var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 5L5.41821 6.08303C5.11571 6.14353 4.96446 6.17377 4.84129 6.24733C4.7324 6.31236 4.63979 6.40139 4.57052 6.50763C4.49216 6.6278 4.45597 6.77774 4.38358 7.07761L1.66669 18.3333M1.66669 18.3333L12.9224 15.6164C13.2223 15.5441 13.3722 15.5079 13.4924 15.4295C13.5986 15.3602 13.6877 15.2676 13.7527 15.1587C13.8262 15.0356 13.8565 14.8843 13.917 14.5818L15 9.16666M1.66669 18.3333L7.98835 12.0117M17.3905 6.55719L13.4428 2.60947C13.1128 2.27946 12.9478 2.11445 12.7575 2.05263C12.5902 1.99825 12.4099 1.99825 12.2425 2.05263C12.0522 2.11445 11.8872 2.27946 11.5572 2.60947L10.9428 3.22385C10.6128 3.55387 10.4478 3.71888 10.386 3.90915C10.3316 4.07652 10.3316 4.25681 10.386 4.42418C10.4478 4.61445 10.6128 4.77946 10.9428 5.10947L14.8905 9.05719C15.2206 9.3872 15.3856 9.55221 15.5758 9.61403C15.7432 9.66841 15.9235 9.66841 16.0909 9.61403C16.2811 9.55221 16.4462 9.3872 16.7762 9.05719L17.3905 8.44281C17.7206 8.11279 17.8856 7.94778 17.9474 7.75751C18.0018 7.59014 18.0018 7.40985 17.9474 7.24248C17.8856 7.05221 17.7206 6.8872 17.3905 6.55719ZM9.16669 9.16666C10.0872 9.16666 10.8334 9.91286 10.8334 10.8333C10.8334 11.7538 10.0872 12.5 9.16669 12.5C8.24621 12.5 7.50002 11.7538 7.50002 10.8333C7.50002 9.91286 8.24621 9.16666 9.16669 9.16666Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature);
export default __webpack_public_path__ + "static/media/signature.554109e58adf575fba88a85fb4efe71a.svg";
export { ForwardRef as ReactComponent };